package com.patronat.top.dto.venues

import kotlinx.datetime.LocalTime
import kotlinx.serialization.Serializable

@Serializable
enum class DayOfWeek {
    MONDAY, TUESDAY, WEDNESDAY, THURSDAY, FRIDAY, SATURDAY, SUNDAY
}

@Serializable
data class VenueSchedule(
    val workDays: List<WorkDay>
)

@Serializable
data class WorkDay(
    val day: DayOfWeek,
    val isOpen: Boolean,
    val openTime: LocalTime? = null,   // Було String, стало LocalTime
    val closeTime: LocalTime? = null,
    val breakStart: LocalTime? = null,
    val breakEnd: LocalTime? = null
)